import Cookies from 'js-cookie';

export function setSmsPopupDismissedCookie() {
  const thirtyDaysFromNow = new Date(Date.now() + 60 * 60 * 1000 * 24 * 30);
  Cookies.set('smsPopupDismissed', 'true', {
    expires: thirtyDaysFromNow,
  });
}
